import { useState } from 'react';
import { useT } from '../i18n/translations';
import './MeetingControls.css';

/* ── Inline SVG icons (white fill inherited from button) ──── */
const IconMicOn = () => (
  <svg viewBox="0 0 24 24"><path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V20H9v2h6v-2h-2v-2.08A7 7 0 0 0 19 11h-2z"/></svg>
);
const IconMicOff = () => (
  <svg viewBox="0 0 24 24"><path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3 3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V20H9v2h6v-2h-2v-2.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"/></svg>
);
const IconCamOn = () => (
  <svg viewBox="0 0 24 24"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/></svg>
);
const IconCamOff = () => (
  <svg viewBox="0 0 24 24"><path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2 2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"/></svg>
);
const IconScreen = () => (
  <svg viewBox="0 0 24 24"><path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/><path d="M8 13h3v3h2v-3h3l-4-4-4 4z"/></svg>
);
const IconEndCall = () => (
  <svg viewBox="0 0 24 24"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
);
const IconUsers = () => (
  <svg viewBox="0 0 24 24"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
);
const IconChat = () => (
  <svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>
);
const IconVote = () => (
  <svg viewBox="0 0 24 24"><path d="M18 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-5 14H7v-2h6v2zm4-4H7v-2h10v2zm0-4H7V7h10v2z"/></svg>
);
const IconRecord = () => (
  <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="7"/></svg>
);
const IconStop = () => (
  <svg viewBox="0 0 24 24"><rect x="6" y="6" width="12" height="12" rx="1.5"/></svg>
);

export default function MeetingControls({
  micOn,
  cameraOn,
  screenSharing,
  isHost,
  participantCount,
  waitingCount,
  chatOpen,
  unreadChat,
  decisionsOpen,
  decisionCount,
  isRecording,
  participantsOpen,
  onToggleParticipants,
  onToggleChat,
  onOpenVote,
  onToggleDecisions,
  onToggleMic,
  onToggleCamera,
  onToggleScreen,
  onToggleRecording,
  onLeave,
  onEndMeeting,
}) {
  const t = useT();
  const [confirmEnd, setConfirmEnd] = useState(false);

  function handleEndClick() {
    if (isHost) setConfirmEnd(true);
    else onLeave();
  }

  return (
    <>
      {/* End-meeting confirmation dialog */}
      {confirmEnd && (
        <div className="mctrl__confirm-overlay" onClick={() => setConfirmEnd(false)}>
          <div className="mctrl__confirm-box" onClick={e => e.stopPropagation()}>
            <div className="mctrl__confirm-icon">
              <IconEndCall />
            </div>
            <h3>{t('room.endConfirmTitle')}</h3>
            <p>{t('room.endConfirmMsg')}</p>
            <div className="mctrl__confirm-actions">
              <button
                className="mctrl__confirm-btn mctrl__confirm-btn--danger"
                onClick={() => { setConfirmEnd(false); onEndMeeting(); }}
              >
                {t('room.endForAll')}
              </button>
              <button
                className="mctrl__confirm-btn mctrl__confirm-btn--neutral"
                onClick={() => { setConfirmEnd(false); onLeave(); }}
              >
                {t('room.leaveOnly')}
              </button>
              <button
                className="mctrl__confirm-btn mctrl__confirm-btn--ghost"
                onClick={() => setConfirmEnd(false)}
              >
                {t('common.cancel')}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="mctrl">
        {/* Mic */}
        <button
          className={`mctrl__btn${micOn ? '' : ' mctrl__btn--off'}`}
          onClick={onToggleMic}
          title={micOn ? t('room.mute') : t('room.unmute')}
        >
          {micOn ? <IconMicOn /> : <IconMicOff />}
          <span className="mctrl__tooltip">{micOn ? t('room.mute') : t('room.unmute')}</span>
        </button>

        {/* Camera */}
        <button
          className={`mctrl__btn${cameraOn ? '' : ' mctrl__btn--off'}`}
          onClick={onToggleCamera}
          title={cameraOn ? t('room.stopVideo') : t('room.startVideo')}
        >
          {cameraOn ? <IconCamOn /> : <IconCamOff />}
          <span className="mctrl__tooltip">{cameraOn ? t('room.stopVideo') : t('room.startVideo')}</span>
        </button>

        {/* Screen share */}
        <button
          className={`mctrl__btn${screenSharing ? ' mctrl__btn--screen-active' : ''}`}
          onClick={onToggleScreen}
          title={screenSharing ? t('room.stopShare') : t('room.shareScreen')}
        >
          <IconScreen />
          <span className="mctrl__tooltip">{screenSharing ? t('room.stopShare') : t('room.shareScreen')}</span>
        </button>

        {/* Record — host only */}
        {isHost && (
          <button
            className={`mctrl__btn${isRecording ? ' mctrl__btn--recording' : ''}`}
            onClick={onToggleRecording}
            title={isRecording ? t('room.stopRecording') : t('room.startRecording')}
          >
            {isRecording ? <IconStop /> : <IconRecord />}
            <span className="mctrl__tooltip">{isRecording ? t('room.stopRecording') : t('room.startRecording')}</span>
          </button>
        )}

        <div className="mctrl__divider" />

        {/* Participant count — clickable button with join-request badge */}
        <button
          className={`mctrl__pill${participantsOpen ? ' mctrl__pill--active' : ''}`}
          onClick={onToggleParticipants}
          title={t('room.participants')}
        >
          <IconUsers />
          {participantCount}
          {isHost && waitingCount > 0 && (
            <span className="mctrl__unread mctrl__unread--waiting">{waitingCount > 9 ? '9+' : waitingCount}</span>
          )}
        </button>

        {/* Chat */}
        <button
          className={`mctrl__btn${chatOpen ? ' mctrl__btn--screen-active' : ''} mctrl__btn--chat`}
          onClick={onToggleChat}
          title={t('chat.title')}
        >
          <IconChat />
          {unreadChat > 0 && !chatOpen && (
            <span className="mctrl__unread">{unreadChat > 9 ? '9+' : unreadChat}</span>
          )}
          <span className="mctrl__tooltip">{t('chat.title')}</span>
        </button>

        {/* Decisions list — all members */}
        <button
          className={`mctrl__btn mctrl__btn--decisions${decisionsOpen ? ' mctrl__btn--screen-active' : ''}`}
          onClick={onToggleDecisions}
          title={t('vote.decisionsList')}
        >
          <IconVote />
          {decisionCount > 0 && (
            <span className="mctrl__unread">{decisionCount > 9 ? '9+' : decisionCount}</span>
          )}
          <span className="mctrl__tooltip">{t('vote.decisionsList')}</span>
        </button>

        {/* New vote — host only */}
        {isHost && (
          <button
            className="mctrl__btn mctrl__btn--vote"
            onClick={onOpenVote}
            title={t('vote.newVote')}
          >
            <IconVote />
            <span className="mctrl__tooltip">{t('vote.newVote')}</span>
          </button>
        )}

        <div className="mctrl__divider" />

        {/* Leave / End */}
        <button
          className="mctrl__btn mctrl__btn--end"
          onClick={handleEndClick}
          title={isHost ? t('room.endMeeting') : t('room.leaveMeeting')}
        >
          <IconEndCall />
          <span className="mctrl__tooltip">{isHost ? t('room.endMeeting') : t('room.leaveMeeting')}</span>
        </button>
      </div>
    </>
  );
}
